import { useQuery, keepPreviousData } from "@tanstack/react-query";
import {
  getStationPortalUsers,
  getStationPortalUserByStation,
} from "../../services/stationUserApi";

//* Station portal users list
export const useStationPortalUsers = (filters) =>
  useQuery({
    queryKey: ["stationPortalUsers", filters],
    queryFn: () => getStationPortalUsers(filters),
    placeholderData: keepPreviousData,
  });

//* Portal users of one station (empty array when none). Older backends return only `result`.
export const useStationPortalUsersOfStation = (stationId, enabled = true) =>
  useQuery({
    queryKey: ["stationPortalUser", stationId],
    queryFn: () => getStationPortalUserByStation(stationId),
    enabled: !!stationId && enabled,
    select: (res) => res?.results ?? (res?.result ? [res.result] : []),
    retry: false,
  });
